import { useMutation } from '@tanstack/react-query';
import apiClient from './apiClient';

const statisticsKeys = {
  all: ['statistics'],
  coupons: () => [...statisticsKeys.all, 'coupons'],
};

/**
 * Hook para obtener estadísticas de cupones
 */
export const useCouponsStatistics = () => {
  return useMutation({
    mutationFn: async (filters) => {
      const filteredFilters = Object.fromEntries(
        Object.entries(filters).filter(([_, value]) => value !== "" && value !== null)
      );

      const response = await apiClient.post('statistics/coupons', filteredFilters);
      return response.data;
    },
    onError: (error) => {
      console.error('Error getting coupons statistics:', error);
    },
  });
};